import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddnewSubregion, contentmanager, LocationRes, Locations } from '../Models/contentmanager';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContentManagerService {

  constructor(private http:HttpClient) { }

regionapi:string='https://localhost:7191/api/content-manager'
subrigionApi:string='https://localhost:7191/api/content-manager/upsert-subregion'
AddlocationApi:string='https://localhost:7191/api/content-manager/upsert-locations'

baseurl=`${environment.baseUrl}`

 Addregion(content: contentmanager): Observable<contentmanager> {
  debugger
  return this.http.post<contentmanager>(`${this.baseurl}/content-manager/upsert-region`, content);
}

  
Addsubrigion(subrigion:AddnewSubregion):Observable<AddnewSubregion>
{  debugger
  return this.http.post<AddnewSubregion>(`${this.baseurl}/content-manager/upsert-subregion`,subrigion)
}


AddLocation(location:Locations):Observable<Locations>
{  debugger
  return this.http.post<Locations>(`${this.baseurl}/content-manager/upsert-locations`,location)
}

ShowRegion():Observable<contentmanager[]>
{debugger
return this.http.get<contentmanager[]>(`${this.baseurl}/content-manager/all-regions`)
}

regionimageupload(userId:number,regionid:number,image:File):Observable<contentmanager>

{
    const formData = new FormData();
    formData.append('UserId', userId.toString());
     formData.append('RegionId', regionid.toString());
    formData.append('RegionImage', image);
  return this.http.post<contentmanager>(`${this.baseurl}/content-manager/upsert-region-image`,formData)
}


subregionimageupload(userId:number,regionid:number,image:File):Observable<AddnewSubregion>

{
    const formData = new FormData();
    formData.append('UserId', userId.toString());
     formData.append('SubRegionId', regionid.toString());
    formData.append('SubRegionImage', image);
  return this.http.post<AddnewSubregion>(`${this.baseurl}/content-manager/upsert-subregion-image`,formData)
}


locationimageupload(userId:number,locationId:number,locimage:File):Observable<Locations>

{  debugger
    const formData = new FormData();
    formData.append('UserId', userId.toString());
     formData.append('LocationId', locationId.toString());
    formData.append('LocationImage', locimage);
  return this.http.post<Locations>(`${this.baseurl}/content-manager/upsert-location-image`,formData)
}

deletesubregion(subregionid: number, deletedBy: number): Observable<any> {
  const params = new HttpParams()
    .set('subregionid', subregionid.toString())
    .set('deletedBy', deletedBy.toString());

  return this.http.delete<any>(`${this.baseurl}/content-manager/delete-subregion`, { params });
}
deletelocationapi(locationid:number,deletedby:number):Observable<Locations>
{ const params = new HttpParams()
.set('locationid', locationid.toString())
    .set('deletedby', deletedby.toString());

  return this.http.delete<any>(`${this.baseurl}/content-manager/delete-location`, { params });
}
updateSubregionOrder(subRegionIds: number[]): Observable<any> {
  return this.http.patch(`${this.baseurl}/content-manager/update-subregions-sequence`, 
    subRegionIds );
}



updatelocationOrder(order: number[]): Observable<any> {
  return this.http.patch(`${this.baseurl}/content-manager/update-locations-sequence`, order);

}


deleteregiononapi(regionid: number, deletedby: number): Observable<contentmanager> {
  const params = new HttpParams()
    .set('regionid', regionid.toString())
    .set('deletedBy', deletedby.toString());

  return this.http.delete<contentmanager>(`${this.baseurl}/content-manager/delete-region`, { params });
}


addLocation(location: Locations): Observable<Locations> {
  const formData = new FormData();
    debugger
  formData.append('locationId', location.locationId.toString());
  formData.append('subRegionId', location.subRegionId?.toString() || '');
  formData.append('locationName', location.locationName || '');
  formData.append('createdAt', new Date(location.createdAt).toISOString());
  formData.append('updatedAt', new Date(location.updatedAt).toISOString());

  // 🔸 Add image file if present
  if (location.locationDisplayImageUrl instanceof File) {
    formData.append('locationDisplayImageUrl', location.locationDisplayImageUrl);
  } else {
    formData.append('locationDisplayImageUrl', ''); // Optional fallback
  }

  return this.http.post<Locations>(`${this.baseurl}/content-manager/upsert-locations`, formData);
}

addOrUpdateLocationWithImage(location: Locations, updatedBy: number) {
  const formData = new FormData();
  debugger
  formData.append('locationIds', location.locationId.toString());
  formData.append('subregionID', location.subRegionId?.toString() ?? '');
  formData.append('locationNames', location.locationName ?? '');
  formData.append('createdAts', location.createdAt.toISOString());
  formData.append('updatedAts', location.updatedAt.toISOString());
  formData.append('updatedBys', updatedBy.toString());
  formData.append('Langitude', location.langitude.toString());
  formData.append('Latitude', location.latitude.toString());

  if (location.locationDisplayImageUrl instanceof File) {
    formData.append('locationImages', location.locationDisplayImageUrl, location.locationDisplayImageUrl.name);
  } else if (typeof location.locationDisplayImageUrl === 'string') {
    formData.append('locationImages', location.locationDisplayImageUrl);
  }

  return this.http.post<LocationRes[]>(`${this.baseurl}/content-manager/upsert-locations`, formData);
}




updateLocationAndSubregion( location: Locations, subregionName: string, updatedBy: number) {
  const formData = new FormData();
  debugger

  formData.append('subregionID', location.subRegionId?.toString() ?? '');
  formData.append('SubregionName', subregionName);

  formData.append('locationIds', location.locationId.toString());
  formData.append('locationNames', location.locationName ?? '');
    formData.append('createdAts', location.createdAt.toISOString()); 
  formData.append('updatedAts', location.updatedAt.toISOString());
  formData.append('updatedBys', updatedBy.toString());
    formData.append('Langitude', location.langitude.toString());
  formData.append('Latitude', location.latitude.toString());

  if (location.locationDisplayImageUrl instanceof File) {
    formData.append('locationImages', location.locationDisplayImageUrl, location.locationDisplayImageUrl.name);
  } else if (typeof location.locationDisplayImageUrl === 'string') {
    formData.append('locationImages', location.locationDisplayImageUrl);
  }

  return this.http.post<any[]>(`${this.baseurl}/content-manager/upsert-locations`, formData);
}






}
